import React from "react";
import fondoDeporte from "../../../../../src/assets/images/45deportes.jpg"; // asegurate de tener esta imagen

function TextoDeportivoConFondo() {
  return (
    <div  style={{ ...styles.container, backgroundImage: `url(${fondoDeporte})` }}>
      <div style={styles.overlay}>
        <p  className="fw-bold" style={styles.texto}>
          Enseñamos valores que van más allá de lo deportivo, respetando la individualidad y madurez de cada alumno. Estimulando la creatividad y la expresión afectiva.
          <br /><br />
          Consideramos la actividad física como un pilar fundamental en la formación integral. Nuestro objetivo es que el deporte sea una herramienta para el desarrollo personal, en un entorno de disciplina y contención. Promovemos hábitos de vida saludables, el respeto mutuo, el trabajo en equipo y la superación personal.
          <br /><br />
          Nuestra propuesta incluye Hockey, Rugby y Atletismo, como espacios de crecimiento físico, emocional y social. Además, los intercambios deportivos brindan oportunidades para conocer otras culturas, valores y generar vínculos significativos a través del deporte.
        </p>
      </div>
    </div>
  );
}

const styles = {
  container: {
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    padding: "3rem",
    margin: "2rem auto",
    borderRadius: "12px",
    maxWidth: "1500px",
    position: "relative",
  },
  overlay: {
    backgroundColor: "rgba(255, 255, 255, 0.85)",
    padding: "2rem",
    borderRadius: "12px",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
  },
  texto: {
    fontSize: "1.1rem",
    lineHeight: "1.7",
    color: "#2e7d32",
    textAlign: "justify",
  },
};

export default TextoDeportivoConFondo;
